import { render } from "./CamerasNew.vue?vue&type=template&id=6ece7661&scoped=true"
import script from "./CamerasNew.vue?vue&type=script&lang=js"
export * from "./CamerasNew.vue?vue&type=script&lang=js"

import "./CamerasNew.vue?vue&type=style&index=0&id=6ece7661&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ece7661"]])

export default __exports__